// Время хранится в UTC (ISO 8601), показывается в часовом поясе браузера.
// Даты без времени (YYYY-MM-DD) трактуются как календарные дни в местном поясе.

const DAY = 864e5;
const DATE_ONLY = /^(\d{4})-(\d{2})-(\d{2})$/;

/** Разбирает ISO-время или дату без времени. Дату без времени — как местную полночь. */
export function toDate(v: string | Date): Date {
  if (v instanceof Date) return v;
  const m = DATE_ONLY.exec(v);
  if (m) return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  return new Date(v);
}

/** «6 окт.» */
export const fmtDate = (v: string | Date): string =>
  toDate(v).toLocaleDateString('ru-RU', { day: 'numeric', month: 'short' });

/** «6 октября 2026 г.» */
export const fmtDateFull = (v: string | Date): string =>
  toDate(v).toLocaleDateString('ru-RU', { day: 'numeric', month: 'long', year: 'numeric' });

/** «6 окт., 14:05» */
export const fmtTime = (v: string | Date): string =>
  toDate(v).toLocaleString('ru-RU', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });

/** Полных лет на дату now. */
export function age(dob: string | null | undefined, now: Date = new Date()): number | null {
  if (!dob) return null;
  const d = toDate(dob);
  let a = now.getFullYear() - d.getFullYear();
  if (now < new Date(now.getFullYear(), d.getMonth(), d.getDate())) a--;
  return a;
}

const startOfDay = (d: Date) => new Date(d.getFullYear(), d.getMonth(), d.getDate());

/** Сколько календарных дней от сегодня до срока (отрицательно — срок прошёл). */
export function daysUntil(due: string, now: Date = new Date()): number {
  return Math.round((startOfDay(toDate(due)).getTime() - startOfDay(now).getTime()) / DAY);
}

/** На сколько дней просрочен (минимум 1, как в прототипе). */
export const daysLate = (due: string, now: Date = new Date()): number => Math.max(1, -daysUntil(due, now));

/** Срок меньше чем через 3 дня, но ещё не прошёл. */
export const isSoon = (due: string, now: Date = new Date()): boolean => {
  const d = daysUntil(due, now);
  return d >= 0 && d < 3;
};

/** Дата без времени через n дней в местном поясе: YYYY-MM-DD. */
export function isoDateFromNow(days: number, now: Date = new Date()): string {
  const d = new Date(now.getFullYear(), now.getMonth(), now.getDate() + days);
  const p = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}
